import React from "react";
import styled from "styled-components";
import device from "../helpers/device";
import nl2br from "react-nl2br";
import Category from "./TagCategory";
import { Link } from "react-router-dom";
import { hallImg } from "../assetManager";

function Default() {
  return (
    <Session className="last">
      <div className="top">
        <div className="wrap">
          <div className="hall">
            <img src={hallImg.hall_j} alt="" width="75" />
          </div>
          <div className="title">
            パーくんといっしょにハッキングコンテスト2019
          </div>
        </div>
      </div>
    </Session>
  );
}

export default function({ hall, session, store, scheduleId, ...rest }) {
  if (!store) {
    return <Default />;
  }
  const { entities } = store;
  const category = entities.categories[session.category];

  return (
    <Session {...rest}>
      <Link to={`/sessions/${session.id}`}>
        <div className="top">
          <div className="hall">
            <img src={hallImg[hall]} alt="" width="75" />
          </div>
          <div className="title">{nl2br(session.title)}</div>
          <ul className="speakers">
            {session.speakers.map(speakerId => {
              const speaker = entities.speakers[speakerId];
              const name = speaker ? speaker.name : "";
              return <li key={speakerId}>{name}</li>;
            })}
          </ul>
          {session.remarks && (
            <p className="remarks">{nl2br(session.remarks)}</p>
          )}
        </div>
        <div className="bottom">
          <Category category={category} />
        </div>
      </Link>
    </Session>
  );
}

const Session = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  cursor: pointer;
  height: calc(100% - 20px);
  a,
  .wrap {
    border-left: 4px solid #3f271e;
    padding-left: 10px;
    color: #3f271e;
    text-decoration: none;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .wrap {
    cursor: default;
  }
  @media ${device.mobileL} {
    min-height: 200px;
    margin-left: 30px;
    margin-bottom: 30px;
    a {
      padding-top: 10px;
      padding-left: 20px;
      transition: opacity 0.1s linear;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  &.last {
    @media ${device.mobileL} {
      min-height: auto;
      margin-bottom: 40px;
    }
  }
  .bottom {
    padding-top: 15px;
  }
  .hall {
    margin-bottom: 5px;
  }
  .title {
    font-weight: bold;
    @media ${device.mobileL} {
      margin-bottom: 10px;
    }
  }
  .speakers {
    text-decoration: underline;
  }
  .category {
    display: inline-block;
    line-height: 26px;
    padding: 0 16px;
    color: #3f271e;
    font-weight: bold;
    border-radius: 13px;
    background: #94e7bb;
    font-size: 12px;
  }
  .remarks {
    font-size: 12px;
    margin-top: 5px;
    line-height: 1.5;
  }
`;
